import React, { useEffect, useState } from 'react';
import {
  SettingOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import { Menu, Layout } from 'antd';
import styled from 'styled-components';
import { Link, useLocation, useOutlet } from 'react-router-dom';
import Media from 'src/utils/media';
import { Image, Dropdown } from 'src/components';
import { DEFAULT_AVATAR, LOGO } from 'src/assets/images';
import { logout } from 'src/utils/auth';
import { LOCAL_STORAGE_KEY } from 'src/constants';

const { Header, Content, Sider } = Layout;

const PrivateLayout: React.FC = () => {
  const outlet = useOutlet();
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState<string>('');

  const MENU = [
    {
      key: 'HOMES',
      icon: <UnorderedListOutlined />,
      label: <Link to="/homes">Homes</Link>,
      path: '/homes'
    },
    {
      key: 'Page',
      icon: <SettingOutlined />,
      label: <Link to="/page">Page</Link>,
      path: '/page'
    },
    {
      key: 'Mailto',
      icon: <SettingOutlined />,
      label: <Link to="/mail-setting">Mailto</Link>,
      path: '/mail-setting'
    },
    // {
    //   key: 'CASE_STUDIES',
    //   icon: <UnorderedListOutlined />,
    //   label: <Link to="/case_studies">Case studies</Link>,
    //   path: '/case_studies'
    // },
    // {
    //   key: 'CATEGORIES',
    //   icon: <UnorderedListOutlined />,
    //   label: <Link to="/case_studies">Categories</Link>,
    //   path: '/categories'
    // },
  ];

  useEffect(() => {
    getActiveRoute();
  }, [location.pathname]);

  const getActiveRoute = () => {
    const activeRoute: string =
      location.pathname === '/'
        ? 'SETTING_APPOINTMENT'
        : MENU.find((item) => location.pathname.includes(item.path))?.key ?? '';
    setActiveRoute(activeRoute);
  };

  const items = [
    {
      key: '1',
      label: <div className="lable">Logout</div>,
      onClick: () => logout()
    }
  ];

  const email = localStorage.getItem(LOCAL_STORAGE_KEY.EMAIL);

  return (
    <PrivateLayoutStyle>
      <Header className="body-header">
        <HeaderStyle>
          <Image src={LOGO} />
          <UserInfoStyle>
            {
              <div className="header-info">
                <Dropdown
                  trigger={
                    <div className="user-name">
                      <Image width={24} src={DEFAULT_AVATAR} />
                      <div>{email}</div>
                    </div>
                  }
                  items={items}
                  placement="bottomRight"
                />
              </div>
            }
          </UserInfoStyle>
        </HeaderStyle>
      </Header>
      <Layout className="layout-body">
        <Sider
          className="layout-sider"
          breakpoint="lg"
          collapsedWidth="0"
          onBreakpoint={(_) => {}}
          onCollapse={(_) => {}}
        >
          <MenuStyle>
            <Menu
              className="layout-menu"
              defaultSelectedKeys={[MENU[0].key]}
              selectedKeys={[activeRoute]}
              items={MENU}
            />
          </MenuStyle>
        </Sider>
        <Content className="body-content">{outlet}</Content>
      </Layout>
    </PrivateLayoutStyle>
  );
};

export default PrivateLayout;

const PrivateLayoutStyle = styled(Layout)`
  min-height: 100vh;
  width: 100%;

  .body-header {
    background: #0c3255;
    border-bottom: 1px solid rgb(67 61 61);
  }

  .layout-body {
    position: relative;

    .body-footer {
      text-align: center;
    }
    .body-content {
        padding: 20px 30px;
      }
    ${Media.lessThan(Media.SIZE.MD)} {
      .body-content {
        padding: 20px;
      }
    }

    /* .layout-sider {
      background: #0c3255;
    } */
  }
`;

const HeaderStyle = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const UserInfoStyle = styled.div`
  text-align: right;
  .header-info {
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    .lable {
      height: 18px;
    }
    .ant-image {
      height: 48px;
    }
    img {
      cursor: pointer;
    }
    .user-name {
      display: flex;
      gap: 6px;
      font-weight: 700;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      align-items: center;
    }
  }
`;

const MenuStyle = styled.div`
  .layout-menu {
    height: calc(100vh - 64px);
    padding: 0;
    background: #0c3255;
    border: none;
    .ant-menu-item {
      margin: 0px;
      .ant-menu-item-icon {
        color: #ffffff;
      }
      .ant-menu-title-content {
        a {
          color: #ffffff;
        }
      }
      &::after {
        border: none;
      }
    }
    .ant-menu-item-selected {
      background-color: #ffffff;
      margin: 0px;
      .ant-menu-item-icon {
        color: #000000;
      }
      .ant-menu-title-content {
        a {
          color: #000000;
          text-decoration: none;
        }
      }
    }
  }
`;
